module.exports = __webpack_public_path__ + "media/AUDIO 07.3ac8013d.mp3";